/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automation_Template_Category_DealsInputs */

const cs_automation_template_category_deals = /** @type {(inputs: Automation_Template_Category_DealsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obchody`)
};

const en_automation_template_category_deals = /** @type {(inputs: Automation_Template_Category_DealsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deals`)
};

/**
* | output |
* | --- |
* | "Deals" |
*
* @param {Automation_Template_Category_DealsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const automation_template_category_deals = /** @type {((inputs?: Automation_Template_Category_DealsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Template_Category_DealsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_template_category_deals(inputs)
	return cs_automation_template_category_deals(inputs)
});